import { render, staticRenderFns } from "./u-tooltip-outlined-tile.vue?vue&type=template&id=06b68670&scoped=true"
import script from "./u-tooltip-outlined-tile.vue?vue&type=script&lang=js"
export * from "./u-tooltip-outlined-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b68670",
  null
  
)

export default component.exports